import { StoreFontFamily } from '@/types';
import { fetchFontFamilies } from '@/utils/http/fetchFontFamilies';
import { isAdminMode } from '@/utils/params';
import { sortByName } from '@/utils/sortByName';
import { mapFontFamily } from '@/model/font/mapFontFamily';
import { StoreDispatch, Thunk } from '@/redux/types';
import { CoreActionTypes, FontsFetchAction } from '../types';

export const fetchFontFamiliesAction =
  (): Thunk<Promise<StoreFontFamily[]>, FontsFetchAction> => (dispatch: StoreDispatch) =>
    fetchFontFamilies().then((fontFamilies) => {
      const payload = fontFamilies
        .filter((family) => isAdminMode() || !family.deprecated)
        .sort(sortByName)
        .map(mapFontFamily);

      dispatch({ type: CoreActionTypes.FONTS_FETCH, payload });
      return payload;
    });
